import Crud from '../components/ScheduleRooms/Crud.vue'
import Add from '../components/ScheduleRooms/Add.vue'
import Edit from '../components/ScheduleRooms/Edit.vue'
import View from '../components/ScheduleRooms/View.vue'

let routes = {
  path: '/schedule_rooms',
  component: resolve => require(['../components/layout/App'], resolve),
  children: [
    {
      path: '/schedule_rooms',
      name: 'Agendamento de sala',
      component: Crud,
    },
    {
      path: '/schedule_rooms/add',
      name: 'Adicionar reserva de sala',
      component: Add,
    },
    {
      path: '/schedule_rooms/view/:id?',
      name: 'Visualizar reserva de sala',
      component: View,
    },
    {
      path: '/schedule_rooms/edit/:id?',
      name: 'Visualizar reserva de sala',
      component: Edit,
    },
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/schedule_rooms.js